
export const Calculate = (wheelWidth, wheelBackspacing, isMetric) => {

    const result = {
        isValid: false,
        errors: [],
        result: null,
        resultInInches: null,
        resultInMM: null,
    }

    wheelWidth = parseFloat(`${wheelWidth}`);
    wheelBackspacing = parseFloat(`${wheelBackspacing}`);

    if (Validate(wheelWidth, wheelBackspacing, result)) {
        return result;
    }

    result.result = CalculateWheelOffset(wheelWidth, wheelBackspacing, isMetric);

    result.resultInMM = `${result.result} millimeters`;
    result.resultInInches = `${Math.round(((result.result) / 25.4) * 100) / 100} inches`;

    result.isValid = true;
    return result;
}

// Are negative values for backspacing allowed here?
const Validate = (wheelWidth, wheelBackspacing, result) => {

    if (isNaN(wheelWidth)) {
        result.errors.push({
            id: "wheelWidth",
            message: "Please enter a valid number"
        })
    }
    if (wheelWidth < 0 || wheelWidth > 500) {
        result.errors.push({
            id: "wheelWidth",
            message: "Please enter a value between 0 to 500"
        })
    }
    if (isNaN(wheelBackspacing)) {
        result.errors.push({
            id: "wheelBackspacing",
            message: "Please select a valid number"
        })
    }
    if (wheelBackspacing < 0 || wheelBackspacing > 500) {
        result.errors.push({
            id: "wheelBackspacing",
            message: "Please enter a value between 0 to 500"
        })
    }
    return result.errors.length > 0
}

// Is there a way to return two outputs in JS
export const CalculateWheelOffset = (wheelWidth, wheelBackspacing, isMetric) => {
    if (!isMetric) {
        // inches calculation
        return Math.round((25.4 * ((wheelBackspacing - (wheelWidth / 2.0)) - 0.5)) * 1000) / 1000;
    }
    else {
        // mm calculation
        return Math.round((wheelBackspacing - (wheelWidth / 2.0) - 12.7) * 1000) / 1000;
    }
}